import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Nav } from "./Nav";
import { Footer } from "./Footer";
import { MobileStickyDownloadBar } from "./MobileStickyDownloadBar";
import { SeoTags } from "./SeoTags";
import { initAnalytics, trackPageview } from "@/lib/analytics";

let bootstrapped = false;

export const PageShell = ({ children, hideFooter = false }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!bootstrapped) {
      initAnalytics();
      bootstrapped = true;
    }
    trackPageview();
  }, [pathname]);

  return (
    <div className="min-h-screen text-white">
      <SeoTags />
      <Nav />
      <main className="relative pt-24">{children}</main>
      {!hideFooter && <Footer />}
      <MobileStickyDownloadBar />
    </div>
  );
};
